import { render, staticRenderFns } from "./TaskEdit.vue?vue&type=template&id=0be6d654&scoped=true"
import script from "./TaskEdit.vue?vue&type=script&lang=js"
export * from "./TaskEdit.vue?vue&type=script&lang=js"
import style0 from "./TaskEdit.vue?vue&type=style&index=0&id=0be6d654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be6d654",
  null
  
)

export default component.exports